import 'core-js/stable';
import 'regenerator-runtime/runtime';

import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueHeadful from 'vue-headful';
import VueScrollTo from 'vue-scrollto';
import Vuetify from 'vuetify';
import Vuex from 'vuex';

import Api from './api';
import Router from './router';
import Store from './store';
import App from './App.vue';

import './registerServiceWorker';

// import styles
import './styles/global.scss';

Api.init();

// eslint-disable-next-line no-undef
Vue.use(CKEditor);
Vue.use(VeeValidate, {
  classNames: { valid: 'valid', invalid: 'invalid' },
  classes: true,
});
Vue.use(VueScrollTo);
Vue.use(Vuetify);
Vue.use(Vuex);
Vue.component('vue-headful', VueHeadful);

Vue.config.productionTip = false;

// eslint-disable-next-line
new Vue({
  render: h => h(App),
  mounted() {
    // Global Error Handling
    this.$store.watch(
      state => state.Http.error,
      () => {
        this.$router.push({ name: 'error' });
      },
    );
  },
  router: Router,
  store: Store,
}).$mount('#app');
